import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RegistrationComponent } from './registration/registration.component';
import { VendorRegistrationComponent } from './vendor/vendor-registration.component';
import { RegistrationSuccessComponent } from './registration/registration-success/registration-success-component';
import { ResetPasswordComponent } from './registration/reset-password/reset-password-component';
import { OrderDetailsComponent } from './dashboard/order-details/order-details.component';
import { OutstandingReportComponent } from './outstanding-report/outstanding-report.component';
import { LeaverequestComponent } from './leaverequest/leaverequest.component';
import { ApplyleaveComponent } from './applyleave/applyleave.component';
import { SalaryadvanceRequestsComponent } from './salaryadvance-requests/salaryadvance-requests.component';
import { ApplySalaryadvanceComponent } from './apply-salaryadvance/apply-salaryadvance.component';
import { ApplyLoanComponent } from './apply-loan/apply-loan.component';
import { LoanRequestsComponent } from './loan-requests/loan-requests.component';
import { VendorEvaluationComponent } from './registration/vendor-evaluation/vendor-evaluation.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'order-details/:id', component: OrderDetailsComponent },
  { path: 'outstanding-report', component: OutstandingReportComponent },
  { path: 'registration', component: RegistrationComponent },
  { path: 'vendor-registration', component: VendorRegistrationComponent },
  { path: 'vendor-evaluation/:id', component: VendorEvaluationComponent },
  { path: 'registration-success/:id/:usertype', component: RegistrationSuccessComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'leave-request', component: LeaverequestComponent },
  { path: 'apply-leave', component: ApplyleaveComponent },
  { path: 'apply-salary-advance', component: ApplySalaryadvanceComponent },
  { path: 'salary-advance-status', component: SalaryadvanceRequestsComponent },
  { path: 'apply-loan', component: ApplyLoanComponent },
  { path: 'loan-request-status', component: LoanRequestsComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
